/*
Description
    Thin API wrapper for Sizer Console (Project 2116, Almondco Intake Masters
    Migration). Feature-scoped, matching the sibling
    almondco-scheme-price.service.js/almondco-grower-pool-split.service.js
    convention - one service file per screen, not folded into the general
    IntakeSettingService.

History
    06Sep2026 (SD)
        - #76661: 2116 - UI - Sizer Console detail panel - header fields and
          banded Cell grid. Added getSizerConsoleSummary (single-row lookup by
          RecordId, resolves the header on baseView.id change - row click or a
          direct/bookmarked URL, matching AlmondcoSchemePriceService's own
          getSchemePriceSummary), getConsoleCells (the detail panel's own Cell
          grid load, $filter=ConsoleID eq {id}&$orderby=CellOrder asc per
          technical-design.md §5), and saveSizerConsole (POST
          api/Save_SimarlooConsole, #76659's endpoint).

(c) Copyright Graycorp Pty Ltd (ABN 12 082 807 761). All Rights Reserved.
*/
import ApiService from "../../api.service";
import appConfig from "../../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const AlmondcoSizerConsoleService = {
  // §5: AlmondcoSizerConsoleSummary, filtered to a single row's RecordId -
  // resolves the header (and, since #76661, the audit block) on
  // baseView.id change, whether that's a row click or a direct/bookmarked
  // URL. No second raw-header fetch against api/SimarlooConsoles - this one
  // summary row already carries every field the detail panel needs
  // (technical-design.md §9 Story 2).
  async getSizerConsoleSummary(recordId) {
    var url = `api/AlmondcoSizerConsoleSummary?$filter=RecordId eq ${recordId}`;
    return await ApiService.get(url);
  },

  // §5: the detail panel's own Cell grid load - every Cell belonging to
  // this Console, in CellOrder ascending order (BR-04).
  async getConsoleCells(consoleRecordId) {
    var url = `api/SimarlooConsoleCells?$filter=ConsoleID eq ${consoleRecordId}&$orderby=CellOrder asc`;
    return await ApiService.get(url);
  },

  // POST api/Save_SimarlooConsole (#76659) - consolidated save of the
  // Console header and every submitted Cell row together (§9 Story 5).
  async saveSizerConsole(payload) {
    return await ApiService.post("api/Save_SimarlooConsole", payload);
  },
};

export { AlmondcoSizerConsoleService };
